import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import vueAwesomeCountdown from 'vue-awesome-countdown';

import pt from 'vuetify/es5/locale/pt';

import moment from 'moment';
import momentTimezone from 'moment-timezone';


Vue.use(Vuetify);
Vue.use(vueAwesomeCountdown, 'vac');

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#93291E',
        secondary: '#02A554',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        yellow: '#FFFDE3',
        gray: '#6F6F6F',
        lightGray: '#F7F7F7',
        white: '#ffffff',
        black: '#000000',
      },
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
});

Vue.filter('formatDate', (value = '') => {
  if (value) {
    return moment(value).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateTime', (value = '') => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm');
  }
});

Vue.filter('formatDateTZ', (date, time) => {
  if (!time) return '';
  time = time.toString();
  const data_user = localStorage.getItem('user-data');
  const timeZone = JSON.parse(data_user).time_zone_name;

  return momentTimezone.utc(`${date} ${time}`, 'HH:mm:ss').tz(`${timeZone}`).format('HH:mm:ss');
});
